import { openapiUpdateuserccapproving as getopenapiUpdateuserccapproving , updateappread } from '@/port/clientSide/oaExamineAudit'

export function oaExamineFormdata2Fun(keyA, valO) {
  //格式化approving.formdata数据
  //keyA数组对象属性name和key。valO对象存放数据，对象属性为key
  var formDataNew = [];
  keyA.forEach((elForm)=>{
    var tihsType = elForm.key.split("_")[1];
    var fromDataMain = {
      title:'',
      value:'',
      key:'',
      type:tihsType
    };
    fromDataMain.key = elForm.key;
    fromDataMain.title = elForm.name;
    if(tihsType == "checkbox"){
      var thisVal = [];
      if(valO){
        thisVal = valO[elForm.key];
        if(typeof (thisVal) == "string"){
          if(thisVal.indexOf("[")==-1){
            thisVal = thisVal.split(",");
          }else if (Number(thisVal.indexOf("[")) !== -1 && Number(thisVal.indexOf("]")) === -1){
            let len = thisVal.split("[")
            thisVal = len[1]
          } else {
            thisVal = JSON.parse(thisVal);
          }
        }
      }
      fromDataMain.value = thisVal;
    }else if(tihsType == "relation-radio"){
      if(elForm && elForm.list){
        if(typeof (valO[elForm.key])== "object"){
          fromDataMain.value = oaExamineFormdata2Fun(elForm.list,valO[elForm.key][0]);
        }
      }
      if(valO && typeof (valO[elForm.key]) == "string" ){
        fromDataMain.relName = valO[elForm.key];
      }
    }else if (tihsType == "details"){
      if(elForm.list){
        if(typeof (valO[elForm.key]) == "object"){
          fromDataMain.value = [];
          valO[elForm.key].forEach((deO)=>{
            if(!deO.length){
              fromDataMain.value.push(oaExamineFormdata2Fun(elForm.list,deO));
            }
          });
        }
      }
    }else if (tihsType == "image" || tihsType == "file"){
      let thisVal = [];
      if(valO){
        thisVal = valO[elForm.key];
        if(typeof (thisVal) == "string" && thisVal != ""){
          thisVal = JSON.parse(thisVal);
        }
      }
      fromDataMain.value = thisVal;
    }else if(tihsType == "relation-user"){
      let thisVal = [];
      if(valO){
        thisVal = valO[elForm.key];
        if(typeof (thisVal) == "string"){
          if(thisVal.indexOf("[")==-1){
            thisVal = thisVal.split(",");
          }else{
            thisVal = JSON.parse(thisVal);
          }
        }
      }
      fromDataMain.value = thisVal;
    }else if(tihsType == "ready-widget"){
      fromDataMain.value = [];
      try{
        valO[elForm.key].forEach((deO)=>{
          if(!deO.length){
            fromDataMain.value.push(oaExamineFormdata2Fun(elForm.list,deO));
          }
        });
      }
      catch(error){console.log("预约控件解析错误")}
      //fromDataMain.value = (oaExamineFormdata2Fun(elForm.list,valO[elForm.key]));
    }else {
      if(valO){
        fromDataMain.value = valO[elForm.key];
      }
    }
    formDataNew.push(fromDataMain);
  });
  return formDataNew;
}
//格式化approving.formdata数据
export function oaExamineFormdata(el) {
  try{
    if(el.approving && typeof (el.approving.formdata) == "string" && el.form){
      const formFor= JSON.parse(el.form);
      const formDataOld = JSON.parse(el.approving.formdata);
      el.approving.formdata = oaExamineFormdata2Fun(formFor,formDataOld);
    }
    return el;
  }
  catch (error) {
    console.log(error)
  }
}
//分类。首页
export const classificationAppNameArrObj = ((appArr)=>{
  var newArr = [];
  var newObj = {
    title:'',
    id:'',
    list:[]
  };
  var newArrI = "";
  appArr.forEach((el)=>{
    var falseIs = 0;
    newArr.forEach((elN,index)=>{
      if(el.categoryName == elN.title){
        falseIs = 1;
        newArrI = index;
        return;
      }
    });
    if(falseIs == 1){
      falseIs == 0;
      newArr[newArrI].list.push(el);
    }else {
      newObj = {};
      newObj.title = el.categoryName;
      newObj.id = el.cateId;
      newObj.list = [];
      newObj.list.push(el);
      newArr.push(newObj);
    }
  });
  return newArr;
});
//标签。首页
export const classificationLabelNameArrObj = ((appArr)=>{
  let newArr = [];
  let newObj = {
    title: "",
    labelId: "",
    list:[]
  };
  let newArrI = "";
  appArr.forEach((el)=>{
    let falseIs = 0;
    newArr.forEach((elN,index)=>{
      if(el.labelId == elN.labelId){
        falseIs = 1;
        newArrI = index;
        return;
      }
    });
    if(falseIs == 1){
      falseIs == 0;
      newArr[newArrI].list.push(el);
    }else {
      if(el.labelId && el.label){
        newObj = {};
        newObj.title = el.label.name;
        newObj.labelId = el.label.labelId;
        newObj.list = [];
        newObj.list.push(el);
        newArr.push(newObj);
      }
    }
  });
  return newArr;
});
//是否已读。待我办理的,参数：userapprovingId,isread=1,
export function stayUserIsItReadFunc(data) {
  var userAppro = {
    userApprovingId:data.userapprovingId,
    isread:1
  };
  updateappread(userAppro).then((res) => {
    if(res.code == 0){
      data.isread = 1;
    }
  });
}
/**
 * 告知已读
 * */
export function openapiUpdateuserccapproving (data) {
  getopenapiUpdateuserccapproving(data).then(res=>{
    if(res.code==0){
      data.status=1
    }
  })
}

//过滤值
export const filterDate = (date) => {
  let data = []
  date.forEach((val) => {
    let keyArr = []
    if (val.approving && val.approving.formdata && val.form) {
      val.approving.formdata.forEach(val => {
        let keys = val.key.split('_')
        if (keys[1] && keys[1] === 'text' || keys[1] === 'name' || keys[1] === 'date' || keys[1] === 'textarea' || keys[1] === 'checkbox' || keys[1] === 'relation-check' || keys[1] === 'number' || keys[1] === 'radio') {
          /*if (keys[1] === 'checkbox') {
            val.value = val.value.join(',')
          }*/
          keyArr.push(val)
        }
      })
      if (keyArr.length > 3) {
        keyArr = keyArr.splice(0, 3)
      }
      val.summary = keyArr
    }
    data.push(val)
  })
  return data
}
//打印方法oaAuditPrinting
export function oaAuditPrintingFunc(data, formdata, index) {
  let arr = [];
  data.forEach((el)=>{
    let types = el.title + '_' + el.type;
    if(!el.print&&el.print!=0){
      el.print = 1;
    }
    let obj = {
      title:el.name,
      key:el.title,
      type:el.type,
      print:el.print,
      value:'',
    };
    if (el.printWidth) obj.printWidth = el.printWidth
    if (el.printHeight) obj.printHeight = el.printHeight
    if(el.type === "checkbox"){
      obj.value = formdata[types];
      // obj.value = el.bindinf;
      if(typeof (thisVal) == "string"){
        obj.value = JSON.parse(formdata[types]);
      }
    }else if(el.type === "number"){
      obj.value = formdata[types];
      // obj.value = el.defaultValue;
    }else if(el.type === "relation-user"){
      obj.value = [];
      if(typeof (formdata[types]) == "string"){
        try{
          formdata[types] = JSON.parse(formdata[types]);
        }
        catch (error) {
          // formdata[types] = formdata[types];
        }
      }

      if (formdata[types] && formdata[types].length > 0) {
        formdata[types].forEach((res)=>{
          obj.value.push(res);
        });
      }
    }else if(el.type === "image" || el.type === "file"){
      obj.value = [];
      if(formdata[types] && formdata[types].length>0){
        if(typeof (formdata[types]) == "string"){
          formdata[types] = JSON.parse(formdata[types]);
        }

        formdata[types].forEach((res)=>{
          if(el.type==='image'){
            obj.value.push(res.response);
          }else{
            obj.value.push(res.name);
          }
        });
      }
    }else if(el.type === "ready-widget"){
      let arr = [];
      el.list.forEach((res)=>{
        let listType = res.title + '_' + res.type;
        let obj2 = {
          title:res.name,
          key:res.title,
          type:res.type,
          print:res.print,
          value:formdata[types][0][listType],
          // value:res.bindinf,
        };
        arr.push(obj2);
      });
      obj.value = arr;
    }else if(el.type === "relation-radio" || el.type === "new-rel-radio"){
      const obj2 = {
        title:el.name,
        print:el.print,
        value:formdata[types],
        // value:el.bindinf,
      };
      if(el.list.length > 0){
        obj.value = oaAuditPrintingFunc(el.list, formdata, index);
        obj.value.splice(0,0,obj2);
      }else {
        obj.value = [];
        obj.value.push(obj2);
      }
    }else if(el.type === "details"){
      let detailsFormdata = formdata[types];

      if(detailsFormdata.length > 0){
        obj.value = [];
        let elList = el.list[0] && el.list[0].length > 0 ? el.list[0] : el.list;
        if (detailsFormdata && detailsFormdata.length > 0) {
          detailsFormdata.forEach(res => {
            const arr = oaAuditPrintingFunc(elList, res, index);
            obj.value.push(arr);
          });
        }
      }else {
        obj.value = [];
      }
      obj.printOrientation = el.printOrientation || 'portrait'
    }else {
      obj.value = formdata[types];
    }
    if (el.width) obj.width = el.width
    arr.push(obj);
  });
  return arr;
}
//生成随机数赋值给控件做title唯一标识
export function randomLoadNameTypeKeyFun(nameTypeKeyArr = []) {
  // nameTypeKeyArr 已经存在的nameTypeKey
  //新增key
  const DateRan = new Date().getTime();
  const nameTypeArr = ["a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z"];
  const keyInd = Math.ceil(Math.random()*25);
  let nameTypeKey = nameTypeArr[keyInd]+DateRan;
  //防止数据本身为空 或者重复了
  if(!nameTypeKey || nameTypeKeyArr.includes(nameTypeKey)){
    nameTypeKey = randomLoadNameTypeKeyFun(nameTypeKey);
  }
  return nameTypeKey;
}
